import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, startWith } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';
import { InterviewTemplateScope, InterviewTemplateSelectors } from '@core/interview-templates-data';
import { InterviewTemplate } from '@core/interview-templates-types';

@Injectable({
  providedIn: 'root',
})
export class RequestEvaluationActionDataFacade {
  private readonly store = inject(Store);

  public getEvaluationForms(): Observable<InterviewTemplate[]> {
    return this.store
      .select(InterviewTemplateSelectors.entities({ scope: InterviewTemplateScope.Interview }))
      .pipe(filterBoolean, startWith([]));
  }
}
